import { alpha } from "@mui/material/styles";
import { buttonClasses } from "@mui/material/Button";
// ----------------------------------------------------------------------
const COLORS = [
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "warning",
    "error",
];
// ----------------------------------------------------------------------
export function button(theme) {
    const lightMode = theme.palette.mode === "light";
    const rootStyles = (ownerState) => {
        const inheritColor = ownerState.color === "inherit";
        const containedVariant = ownerState.variant === "contained";
        const outlinedVariant = ownerState.variant === "outlined";
        const textVariant = ownerState.variant === "text";
        const softVariant = ownerState.variant === "soft";
        const smallSize = ownerState.size === "small";
        const mediumSize = ownerState.size === "medium";
        const largeSize = ownerState.size === "large";
        const defaultStyle = Object.assign(Object.assign({ borderRadius: 40 }, (inheritColor && Object.assign(Object.assign(Object.assign(Object.assign({}, (containedVariant && {
            color: lightMode
                ? theme.palette.common.white
                : theme.palette.grey[800],
            backgroundColor: lightMode
                ? theme.palette.grey[800]
                : theme.palette.common.white,
            "&:hover": {
                backgroundColor: lightMode
                    ? theme.palette.grey[700]
                    : theme.palette.grey[400],
            },
        })), (outlinedVariant && {
            borderColor: alpha(theme.palette.grey[500], 0.32),
            "&:hover": {
                backgroundColor: theme.palette.action.hover,
            },
        })), (textVariant && {
            "&:hover": {
                backgroundColor: theme.palette.action.hover,
            },
        })), (softVariant && {
            color: theme.palette.text.primary,
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            "&:hover": {
                backgroundColor: alpha(theme.palette.grey[500], 0.24),
            },
        })))), (outlinedVariant && {
            "&:hover": {
                borderColor: "currentColor",
                boxShadow: "0 0 0 0.5px currentColor",
            },
        }));
        const colorStyle = COLORS.reduce((acc, color) => {
            if (ownerState.color === color) {
                // For tertiary, use tertiary[40], for others use main color
                const mainColor = color === "tertiary"
                    ? theme.palette.tertiary[40]
                    : theme.palette[color].main;
                // Type guard: ensure mainColor is defined
                if (!mainColor)
                    return acc;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, acc), (containedVariant && {
                    backgroundColor: mainColor,
                    "&:hover": {
                        boxShadow: theme.customShadows[color],
                        backgroundColor: color === "tertiary"
                            ? theme.palette.tertiary[30]
                            : alpha(mainColor, 0.9),
                    },
                    color: theme.palette.common.white,
                })), (softVariant && {
                    color: color === "tertiary"
                        ? theme.palette.tertiary[40]
                        : theme.palette[color][lightMode ? "dark" : "light"],
                    backgroundColor: alpha(mainColor, 0.08),
                    "&:hover": {
                        backgroundColor: alpha(mainColor, 0.32),
                    },
                })), (outlinedVariant && {
                    color: color === "tertiary" ? theme.palette.tertiary[40] : mainColor,
                    border: color === "tertiary"
                        ? `1px solid ${alpha(theme.palette.primary.main, 0.8)}`
                        : `1px solid ${alpha(mainColor, 0.48)}`,
                    "&:hover": {
                        backgroundColor: alpha(mainColor, 0.08),
                        border: color === "tertiary"
                            ? `1px solid ${theme.palette.primary.main}`
                            : `1px solid ${mainColor}`,
                    },
                }));
            }
            return acc;
        }, {});
        const disabledState = {
            [`&.${buttonClasses.disabled}`]: Object.assign({}, (softVariant && {
                backgroundColor: theme.palette.action.disabledBackground,
            })),
        };
        const size = Object.assign(Object.assign(Object.assign({}, (smallSize && Object.assign({ height: 30, fontSize: 13, paddingLeft: 8, paddingRight: 8 }, (textVariant && {
            paddingLeft: 4,
            paddingRight: 4,
        })))), (mediumSize && Object.assign({ paddingLeft: 12, paddingRight: 12, fontWeight: 500 }, (textVariant && {
            paddingLeft: 8,
            paddingRight: 8,
        })))), (largeSize && Object.assign({ height: 48, fontSize: 15, paddingLeft: 16, paddingRight: 16, fontWeight: 500 }, (textVariant && {
            paddingLeft: 10,
            paddingRight: 10,
        }))));
        return [defaultStyle, colorStyle, disabledState, size];
    };
    return {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyles(ownerState),
            },
        },
    };
}
